import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PcfService {
  serviceUrl: any;
  subs: Subscription;
  acctRef: any;
  imp: any[];

  constructor(private http: HttpClient) { }
  Incomecashflowfliter(serivceUrl, acctRef, params) {
    let timeNow = Date.now();
    const options = {
      headers: new HttpHeaders().append('Account', acctRef),
      params: params
    };

    return this.http.get(serivceUrl + '/portfolio/' + 'urn:id:headers.Account' + '/pcfCshFlw/summary' + '?time=' + timeNow, options);
  }
  FixedIncomecashflowfliter(serivceUrl, acctRef, params) {
    let timeNow = Date.now();
    console.log('acc ref i got', acctRef);
    console.log('service ref i got', serivceUrl);
    const options = {
      headers: new HttpHeaders().append('Account', acctRef),
      params: params
    };
    return this.http.get(serivceUrl + '/portfolio/' + 'urn:id:headers.Account' + '/fiCshFlw/summary'+ '?time=' + timeNow, options);
  }
  Maturityschedule(serviceUrl, acctRef, params) {
    let timeNow = Date.now();
    console.log('acc ref i got', acctRef);
    const options = {
      headers: new HttpHeaders().append('Account', acctRef),
      params: params
    };
    return this.http.get(serviceUrl + '/trading/' + 'urn:id:headers.Account' + '/maturitySchedule' + '?time=' + timeNow, options);
  }
  IncomeCashPopup(serviceUrl, acctRef, params) {
    let timeNow = Date.now();
    console.log('acc ref i got', acctRef);
    const options = {
      headers: new HttpHeaders().append('Account', acctRef),
      params: params
    };
    return this.http.get(serviceUrl + '/trading/' + acctRef + '/incoming-cash' + '?time=' + timeNow, options);
  }
}
